const MESSAGE = {
  EMAIL_REQUIRED: 'メールを入力してください',
  EMAIL_FORMAT: 'メールフォーマットが正しくありません',
  EMAIL_OR_PASSWORD: 'メールまたはパスワードが正しくありません',
  EMAIL_HAS_ALREADY: 'メールアドレスが既に存在しています',
  EMAIL_NOT_EXIST: 'メールアドレスが登録されていません',
  PASSWORD_REQUIRED: 'パスワードを入力してください',
  PASSWORD_FORMAT: 'パスワードフォーマットが正しくありません',
  PASSWORD_CONFIRM: '新しいパスワードと再入力パスワードが一致しません、再度ご確認お願いします。',
  PASSWORD_INCORRECT: '現在のパスワードが正しくありません',
  URL_FORGOT_PASS: '認証URLの有効期限が切れています。再度メールアドレスを入力してください',
  NAME_REQUIRED: '名前を入力してください',
  PHONE_FORMAT: '電話番号フォーマットが正しくありません',
  PHONE_REQUIRED: '電話番号を入力してください',
  AVATAR_FORMAT: '画像ファイルフォーマットが正しくありません·',

  COMPANY_NAME_REQUIRED: '会社名を入力してください',
  NUMBER_EMPLOYEE_FORMAT: '0より大きい整数を入力してください',
  CAPITAL_FORMAT: '0より大きい整数を入力してください',
  ZIPCODE_HEAD_FORMAT: '全角数字を3桁入力してください',
  ZIPCODE_TAIL_FORMAT: '全角数字を４桁入力してください',
  REPRESENTATIVE_PHONE_REQUIRED: '代表電話番号を入力してください',
  REQUIREMENT_REQUIRED: '要件を入力してください',
  CONTENT_REQUIRED: '内容を入力してください',
  REPRESENTATIVE_NAME_REQUIRED: '代表者名を入力してください',
  FILE_REQUIRED: 'ファイルを選択してください',
  FILE_NAME_REQUIRED: 'ファイル名を入力してください',
  FILE_FORMAT: 'ファイルのフォーマットが正しくありません',
  FILE_SIZE: 'ファイルサイズ制限を超えました',
  FILE_NAME_FORMAT: 'ファイル名のフォーマットが正しくありません',
  FILE_NAME_AVAIABLE: 'ファイル名が既に存在しています',
  FOLDER_NAME: 'フォルダ名が既に存在しています·',
  FOLDER_NAME_FORMAT: 'フォルダ名のフォーマットが正しくありません',
  ROLE_REQUIRED: 'ロールを選択してください',
  FOLDER_REQUIRED: 'フォルダ名を入力してください',
  FILE_DESCRIPTION: '説明を1000文字以下で入力してください',
  VIDEO_SIZE: '動画は長さが300分まで、容量が50 MBまでロードしてください',
  IMAGE_SIZE: '添付ファイル5MBを超えました',
  PDF_SIZE: '添付ファイル2MBを超えました',
  UPLOAD_MESSAGE: 'アップロード中はページを閉じないでください'
}
export {
  MESSAGE
}



// WEBPACK FOOTER //
// ./src/utils/errorjapanese.js